<template>
    <div>
        <b-button class="mt-1" variant="primary" @click="isModalOpen=true">
            Dienstleisteraktion protokollieren
        </b-button>

        <div class="clear"/>

        <b-modal
            v-model="isModalOpen"
            :cancel-disabled="isLoading"
            cancel-title="Abbrechen"
            :no-close-on-backdrop="isLoading"
            :no-close-on-esc="isLoading"
            :ok-disabled="isLoading"
            ok-title="Speichern"
            size="xl"
            title="Dienstleisteraktion protokollieren"
            @hidden="reset()"
            @ok="saveExternalServiceProviderAction"
            @show="createExternalServiceProviderAction">
            <div v-if="isLoading" class="d-flex justify-content-center">
                <csp-loading-indicator/>
            </div>
            <div v-else>
                <csp-desktop-info-card
                    class="editMode"
                    :cols="12"
                    icon="inticon-users">
                    <b-row>
                        <csp-desktop-info-card-element
                            class="col-4"
                            :form-context="externalFormContext"
                            label="Externer Dienstleister"
                            :options-loader="loadExternalServiceProviderOptions"
                            property="externalServiceProvider"
                            :required="true"
                            type="autocomplete"/>
                        <csp-desktop-info-card-element
                            class="col-4"
                            :dependencies="['externalServiceProvider']"
                            :form-context="externalFormContext"
                            label="Aktion"
                            :options-loader="loadServiceActionOptions"
                            property="externalServiceAction"
                            :required="true"
                            type="autocomplete"/>
                        <csp-desktop-info-card-element
                            class="col-4"
                            :form-context="externalFormContext"
                            label="Datum"
                            property="dateOfAction"
                            :required="true"
                            type="datepicker"/>
                        <csp-desktop-info-card-element
                            class="col-4"
                            :form-context="externalFormContext"
                            label="Vorname"
                            property="firstName"
                            :required="false"
                            type="text"/>
                        <csp-desktop-info-card-element
                            class="col-4"
                            :form-context="externalFormContext"
                            label="Nachname"
                            property="lastName"
                            :required="false"
                            type="text"/>
                        <b-col cols="4"/>
                        <csp-desktop-info-card-element
                            class="col-8"
                            :form-context="externalFormContext"
                            label="Kommentar"
                            property="comment"
                            :required="false"
                            type="textarea"/>
                    </b-row>
                </csp-desktop-info-card>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import Container from '@services/Container';
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';
    import FormContext from '@desktop/components/FormContext';

    const container = Container.getInstance();
    const recordRepository = container.getDesktopRecordRepository();

    export default {
        name: 'ExternalServiceProviderDocumentation',
        mixins: [FormDataMixin],
        props: {
            recordId: {
                type: Number,
                required: true,
            },
        },
        emits: ['saved'],
        data() {
            return {
                isLoading: true,
                isModalOpen: false,
                initialFormContexts: {
                    externalFormContext: new FormContext({
                        name: 'external-service-provider-documentation',
                        isAlwaysInEditMode: true,
                    }),
                },
            }
        },
        computed: {
            externalFormContext() {
                return this.initialFormContexts.externalFormContext;
            },
            externalServiceProvider() {
                return this.externalFormContext.form.getProperty('externalServiceProvider');
            },
        },
        methods: {
            saveExternalServiceProviderAction(bvModalEvent) {
                bvModalEvent.preventDefault();
                this.isLoading = true;
                const saveFunction = (objectId, postData) =>
                    recordRepository.saveExternalServiceProviderAction(this.recordId, postData);
                this.saveFormData(this.externalFormContext, saveFunction)
                    .then(() => {
                        this.isModalOpen = false;
                    })
                    .finally(() => {
                        this.isLoading = false;
                        this.$emit('saved');
                    });
            },
            createExternalServiceProviderAction() {
                this.isLoading = true;
                const loadFunction = () => recordRepository.createExternalServiceProviderAction(this.recordId);
                this.loadFormData(loadFunction)
                    .finally(() => {
                        this.isLoading = false;
                    });
            },
            loadExternalServiceProviderOptions() {
                return recordRepository.getExternalServiceProviderOptions(
                    this.recordId
                )},
            loadServiceActionOptions() {
                return recordRepository.getExternalServiceProviderActionOptions(
                    this.recordId, this.externalServiceProvider
                )},
            reset() {
                this.isLoading = true;
                this.externalFormContext.form.reset();
            },
        },
    }

</script>
